import { createFromIconfontCN } from '@ant-design/icons';

//定义项目中使用的图标
const FontIcon = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2576875_mxeqi0a2b6g.js',
});

export default FontIcon;